export const getApiUrl = (path = "") => {
  let formattedPath = path;
  if (formattedPath && typeof formattedPath === 'string') {
    formattedPath = formattedPath.replace(/^\/Selfie\//i, '/selfie/').replace(/^\/Groups\//i, '/groups/');
  }

  // Always use REACT_APP_API_URL if it exists (for both dev and prod)
  // Fall back to window.location.origin if it's undefined
  let base = "";
  if (typeof process !== "undefined" && process.env.REACT_APP_API_URL !== undefined) {
    base = process.env.REACT_APP_API_URL;
  } else {
    base = `${window.location.protocol}//${window.location.host}`;
  }
  
  // Ensure we don't have double slashes if formattedPath starts with a slash
  if (base.endsWith('/') && formattedPath.startsWith('/')) {
    formattedPath = formattedPath.substring(1);
  }
  
  return `${base}${formattedPath}`;
};

export const getRelativeUrl = (url) => {
  if (!url) return "";
  // Extract path starting from /groups/ or /selfie/
  const match = url.match(/\/(groups|selfie)\/.*/i);
  if (match) {
    const relativeUrl = match[0];
    // Force lowercase for the root folder so NGINX can match it properly
    return relativeUrl.replace(/^\/Selfie\//i, '/selfie/').replace(/^\/Groups\//i, '/groups/');
  }
  return url;
};
